import React from "react";
import { Field } from "react-final-form";

/**
 * Base field for all Final Forms, contains the general logic to store the data in Final Form.
 * 
 * Props:
 * - fieldComponent: Component that will render the field, as this component is just a wrapper for the Final Form field.
 * - changeEvent: Name of the event that field fires when the user changes the value. React Native uses onChangeText (default), but other fields like react-select use onChange.
 * - onChangeText: Fired when the value of the field changes, this event unifies whatever event the rendering field may fire when the value changes (react-select will also fire onChangeText for us).
 * - onBlur: Fired when the field loses focus.
 */
const FormBaseField = ({
  fieldComponent: FieldComponent,
  onChangeText,
  onBlur,
  changeEvent,
  setNegative,
  hideError,
  error,
  ...restProps
}) => (
  <Field name={restProps.name}>
    {({ input, meta }) => {
      const { name, value } = input,
        // We separate out the events so that the change event name can be different based on the changeEvent prop
        events = {
          [changeEvent]: text => {
            input.onChange(text);

            onChangeText(text);
          },
          onBlur: e => {
            input.onBlur();

            onBlur(e);
          }
        };

      return (
        <FieldComponent
          value={setNegative ? (value < 0 ? -value : value) : value}
          error={hideError ? null : error || meta.error || meta.submitError}
          {...restProps}
          {...events}
        />
      );
    }}
  </Field>
);

FormBaseField.defaultProps = {
  changeEvent: "onChangeText",
  onChangeText: () => {},
  onBlur: () => {}
};

export default FormBaseField;
